import {makeRequest} from "../../lib/api/request";
import {useEffect, useState, useCallback} from "react";
import {Button} from "react-bootstrap";
import {useSearchParams} from "react-router-dom";
import Select from 'react-select';
import {STATES_BY_CODE} from "../../lib/utils/states";


const USAePay = (props) =>  {
    const [params] = useSearchParams()
    const userId = params.get('userID')
    const dataId = params.get('dataID')
    const sessionToken = params.get('session_token')

    const [client, setClient] = useState(null)
    const [paymentCard, setPaymentCard] = useState(null)
    const [cardFieldsLoaded, setCardFieldsLoaded] = useState(false)
    const [clientToken, setClientToken] = useState("")
    const [signature, setSignature] = useState("")
    
    const [firstName, setFirstName] = useState("")
    const [lastName, setLastName] = useState("")
    const [street, setStreet] = useState("")
    const [city, setCity] = useState("")
    const [state, setState] = useState(null)
    const [postalcode, setPostalcode] = useState("")
    
    const [success, setSuccess] = useState(false)
    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(false)
    
    // Prepare state options for react-select
    const stateOptions = Object.entries(STATES_BY_CODE).map(([code, name]) => ({
        value: code,
        label: `${code} - ${name}`
    }))


    const loadPublicKey = () => {
        const headers = sessionToken ? { "X-Card-Session-Token": sessionToken } : {};
        makeRequest(`/usaepay/public_key/`, "POST", {
            "user_id": userId,
            "data_id": dataId,
        }, "", headers).then((r) => {
          console.log('USAePay public key response', r)
          setClientToken(r["publicKey"])
          setSignature(r["signature"])
        }).catch((err) => {
          console.error('Error loading public key:', err)
          setError("Failed to load payment form. Please refresh the page.")
        })
    }

    const initializePayJS = useCallback(() => {
        console.log(clientToken)
        if (!clientToken || !window.usaepay) {
            return
        }

        try {
            // Initialize USAePay client
            console.log(clientToken)
            const usaepayClient = new window.usaepay.Client(clientToken)
            setClient(usaepayClient)

            // Create payment card entry
            const cardEntry = usaepayClient.createPaymentCardEntry()

            const style = {
              // can add custom styling here
              base: {
                height: '50px',
                fontSize: '16px',
              },
            }
            // Generate HTML and add to container
            cardEntry.generateHTML(style)
            cardEntry.addHTML('paymentCardContainer')
            
            setPaymentCard(cardEntry)
            
            // Wait a bit for the card fields to actually render in the DOM
            setTimeout(() => {
                const container = document.getElementById('paymentCardContainer')
                if (container && container.children.length > 0) {
                    setCardFieldsLoaded(true)
                }
            }, 1500)
        } catch (err) {
            console.error('Error initializing Pay.js:', err)
            setError("Failed to initialize payment form. Please refresh the page.")
        }
    }, [clientToken])

    const processPayment = () => {
        if (!client || !paymentCard) {
            setError("Payment form not ready. Please wait.")
            return
        }

        setLoading(true)
        setError(null)

        client.getPaymentKey(paymentCard).then(result => {

            try {
                makeRequest("/usaepay/payment_key/", "POST", {
                    "signature": signature,
                    "payment_key": result,
                    "first_name": firstName,
                    "last_name": lastName,
                    "street": street,
                    "city": city,
                    "state": state ? state.value : "",
                    "postalcode": postalcode
                    }).then((r) => {
                            setSuccess(true)
                    console.log("PAYMENT_SUCCESS")
                            window.parent.postMessage("PAYMENT_SUCCESS", "*")
                    }).catch((err) => {
                        console.error('Error saving payment method:', err)
                    const errorMessage = err.message || "Failed to save payment method. Please try again."
                    setError(errorMessage)
                        setLoading(false)
                        if (err.response && err.response.status >= 400) {
                            console.log("PAYMENT_FAIL")
                            window.parent.postMessage("PAYMENT_FAIL", "*")
                        }
                    })
                } catch (error) {
                    console.error('Error when submitting payment_key:', error)
                    setError("Failed to submit payment information.")
                    setLoading(false)
                }

        }).catch((err) => {
            console.error('Error getting payment key:', err)
            setError("Failed to process payment: " + err)
            setLoading(false)
        })
    }

    useEffect(() => {
        if (userId && sessionToken) loadPublicKey()
    }, [userId, sessionToken]);

    useEffect(() => {
        if (clientToken && window.usaepay) {
            initializePayJS()
        } else if (clientToken && !window.usaepay) {
            // Wait for script to load
            const checkScript = setInterval(() => {
                if (window.usaepay) {
                    clearInterval(checkScript)
                    initializePayJS()
                }
            }, 100)
            
            // Timeout after 5 seconds
            setTimeout(() => {
                clearInterval(checkScript)
                if (!window.usaepay) {
                    setError("Payment library failed to load. Please refresh the page.")
                }
            }, 5000)
        }
    }, [clientToken, initializePayJS])

    const inputStyle = { width: "100%", maxWidth: "460px", padding: "8px", fontSize: "16px", border: "1px solid #ccc", borderRadius: "4px", boxSizing: "border-box" }
    const labelStyle = { display: "block", marginBottom: "8px", fontWeight: "500" }
    const fieldContainerStyle = { marginBottom: "20px", width: "100%", maxWidth: "460px" }

    const formContainerStyle = { 
        display: "flex", 
        flexDirection: "column", 
        alignItems: "center", 
        maxWidth: "500px", 
        margin: "0 auto",
        padding: "20px"
    }

    return (<>
        { userId && <>
            {!success ? <div style={formContainerStyle}>
                {/* PayJS Card Entry Container - Above billing address fields */}
                <div
                    id={"paymentCardContainer"}
                    style={{ marginBottom: cardFieldsLoaded ? "5px" : "30px", minHeight: "100px", width: "100%"}}
                />

                {cardFieldsLoaded && (
                    <>
                        <div style={fieldContainerStyle}>
                            <label htmlFor="firstName" style={labelStyle}>First Name *</label>
                            <input
                                id="firstName"
                                type="text"
                                value={firstName}
                                onChange={(e) => setFirstName(e.target.value)}
                                placeholder="Enter first name"
                                style={inputStyle}
                                required
                            />
                        </div>
                        
                        <div style={fieldContainerStyle}>
                            <label htmlFor="lastName" style={labelStyle}>Last Name *</label>
                            <input
                                id="lastName"
                                type="text"
                                value={lastName}
                                onChange={(e) => setLastName(e.target.value)}
                                placeholder="Enter last name"
                                style={inputStyle}
                                required
                            />
                        </div>
                        
                        <div style={fieldContainerStyle}>
                            <label htmlFor="street" style={labelStyle}>Street Address *</label>
                            <input
                                id="street"
                                type="text"
                                value={street}
                                onChange={(e) => setStreet(e.target.value)}
                                placeholder="Enter street address"
                                style={inputStyle}
                                required
                            />
                        </div>
                        
                        <div style={fieldContainerStyle}>
                            <label htmlFor="city" style={labelStyle}>City *</label>
                            <input
                                id="city"
                                type="text"
                                value={city}
                                onChange={(e) => setCity(e.target.value)}
                                placeholder="Enter city"
                                style={inputStyle}
                                required
                            />
                        </div>
                        
                        <div style={fieldContainerStyle}>
                            <label htmlFor="state" style={labelStyle}>State *</label>
                            <Select
                                id="state"
                                value={state}
                                onChange={setState}
                                options={stateOptions}
                                placeholder="Select state"
                                isSearchable
                                isClearable
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        width: "100%",
                                        maxWidth: "460px",
                                        minHeight: "38px",
                                        boxSizing: "border-box"
                                    }),
                                    menu: (base) => ({
                                        ...base,
                                        maxWidth: "460px"
                                    })
                                }}
                                filterOption={(option, inputValue) => {
                                    if (!inputValue) return true;
                                    const searchValue = inputValue.toLowerCase();
                                    return (
                                        option.value.toLowerCase().includes(searchValue) ||
                                        option.label.toLowerCase().includes(searchValue)
                                    );
                                }}
                            />
                        </div>
                        
                        <div style={fieldContainerStyle}>
                            <label htmlFor="postalcode" style={labelStyle}>Postal Code *</label>
                            <input
                                id="postalcode"
                                type="text"
                                value={postalcode}
                                onChange={(e) => {
                                    let value = e.target.value.replace(/\D/g, ''); // Remove non-digits
                                    // Format as 12345-6789 if 9 digits, otherwise just digits
                                    if (value.length > 5) {
                                        value = value.slice(0, 5) + '-' + value.slice(5, 9);
                                    }
                                    setPostalcode(value);
                                }}
                                placeholder="12345 or 12345-6789"
                                style={inputStyle}
                                required
                                maxLength={10}
                                pattern="^\d{5}(-\d{4})?$"
                            />
                            {postalcode && !/^\d{5}(-\d{4})?$/.test(postalcode) && (
                                <div style={{ color: "red", fontSize: "12px", marginTop: "4px" }}>
                                    Please enter a valid 5-digit or 9-digit postal code (e.g., 12345 or 12345-6789)
                                </div>
                            )}
                        </div>
                    </>
                )}

                {error && (
                    <div style={{ color: "red", textAlign: "center", marginBottom: "10px", width: "100%" }}>
                        {error}
                    </div>
                )}

                <div style={{ display: "flex", justifyContent: "center", marginTop: "20px", width: "100%" }}>
                    <style>
                        {`
                            .usaepayPayButton:disabled {
                                border: 1px solid #ccc !important;
                                opacity: 0.65;
                            }
                            .usaepayPayButton:not(:disabled) {
                                border: 1px solid #ccc;
                            }
                        `}
                    </style>
                    <Button
                        className={"usaepayPayButton"}
                        type="primary"
                        disabled={
                            !paymentCard || 
                            loading || 
                            !firstName || 
                            !lastName || 
                            !street || 
                            !city || 
                            !state || 
                            !postalcode ||
                            !/^\d{5}(-\d{4})?$/.test(postalcode)
                        }
                        onClick={processPayment}
                        style={{
                            minWidth: "120px"
                        }}
                    >
                        {loading ? "Processing..." : "Submit"}
                    </Button>
                </div>
            </div>: <div style={{ textAlign: "center" }}>
                <h2>Payment method successfully added.</h2>
            </div>}
        </>}
            {!userId && <div style={{ textAlign: "center" }}>
                <h2>No user id specified</h2>
            </div>}
        </>
    )
}

export default USAePay